import { connect } from 'react-redux'
import { actions } from '../reducers/index.js'
import Search from '../components/Search.jsx'

const mapStateToProps = (state, props) => {
  const isVisible = state.siteSearch.visible
  return {
    isExpanded: isVisible,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onClose: () => {
      dispatch(actions.toggleVisibility())
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Search)
